import { stats } from '@fiverr-private/obs';
import { asGrafanaStat } from '../../../../../shared/stats/asGrafanaStat';

const PROJECT_NAME = 'pinned_flashes';

/**
 * TL;DR
 * You can remove this if the migration to this package is completed.
 *
 * The other instance is V2 - the legacy version of this package.
 * The same event type exists in V2, and is used to verify the
 * total amount of notifications remained the same during the rolling
 * out of this feature.
 */
const INSTANCE_NAME = 'realtime_notifications_package';

const FEATURE_PREFIX = asGrafanaStat(PROJECT_NAME, INSTANCE_NAME);

function count(eventName) {
    stats.count(FEATURE_PREFIX, eventName);
}

export const RealTimeNotificationsStats = {
    count,
};
